import React, { useEffect, useRef, useState } from "react";
import { startCase } from "lodash";

import MyAccountLayout from "./MyAccountLayout";
import MyAccountFilter from "./MyAccountFilter";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import {
  formatDate,
  levelMap,
  toFixedWithoutRounding,
} from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useMyAccount } from "../../context/MyAccountContext";
import { useContextSelector } from "use-context-selector";
import Pagination from "../../components/Pagination";
import { useParams } from "react-router-dom";

const TABS = [
  { key: "Exchange", label: "Exchange", betType: "betfair" },
  { key: "FancyBet", label: "FancyBet", betType: "fancy" },
  { key: "Sportsbook", label: "Sportsbook", betType: "sportBook" },
  { key: "BookMaker", label: "BookMaker", betType: "bookmaker" },
  { key: "parlay", label: "Parlay", betType: "parlay" },
];

const CurrentBetsContent = () => {
  const params = useParams();
  const { summaryData } = useMyAccount();
  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    betType: "all",
    status: "active",
    userType: params.type,
    id: params.id,
  };
  const tableRef = useRef();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const [activeTab, setActiveTab] = useState("Exchange");
  const [data, setData] = useState([]);
  const [openRows, setOpenRows] = useState({});
  const [filter, setFilter] = useState(DEFAULT_FILTER);

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betHistory,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData({ ...response_users.pagination, data: response_users.data });
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.type, filter.page, filter.limit, filter.betType]);

  const handleLimitChange = (e) => {
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const toggleRow = (e, id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
    e.currentTarget.className = openRows[id]
      ? "fas fa-plus-square"
      : "fas fa-minus-square pe-2";
  };

  const currentBetType = filter.betType;
  const rows = data?.data || [];
  return (
    <>
      <div id="report" className="col-center report">
        <div className="box" style={{ alignItems: "baseline" }}>
          <h3
            style={{
              fontSize: "24px",
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            Current Bets
          </h3>
        </div>

        {/* Limit selector */}
        <div id="userTreeDiv" className="total_all">
          <ul style={{ marginBottom: "8px" }} className="acc-info">
            <li className="user">
              <span className={`Bdlevel ${levelMap[summaryData?.userType]}`} />{" "}
              {summaryData?.username}
            </li>
          </ul>
          <span className="spacer" />
          <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
           <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName={"current-bets"}
          />
        </div>

        {/* Table */}
        <div id="reportTable">
          <div
            className="table-responsive data-table"
            style={{ overflow: "auto", whiteSpace: "nowrap" }}
          >
            {currentBetType === "parlay" ? (
              <ParlayTable
                rows={rows}
                tableRef={tableRef}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            ) : (
              <DefaultTable
                rows={rows}
                tableRef={tableRef}
                user={user}
                betType={currentBetType}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            )}
          </div>
          <div className="bottom-pagination">
            {rows.length > 0 && data?.totalRecords > 0 && (
              <Pagination pagination={data} onPageChange={handlePageChange} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const CurrentBets = () => (
  <MyAccountLayout>
    <CurrentBetsContent />
  </MyAccountLayout>
);

/* ------------------------------------------------------------------------ */
/*  Default table: Exchange / FancyBet / Sportsbook / BookMaker             */
/* ------------------------------------------------------------------------ */
function DefaultTable({ rows, tableRef, user, betType, openRows, toggleRow }) {
  return (
    <table
      ref={tableRef}
      id="table_DL"
      className="table-s"
      style={{ display: "table" }}
    >
      <tbody>
        <tr>
          <th width="5%" data-name="betId" className="align-L sort_asc">
            Bet ID
          </th>
          <th width="15%" data-name="eventName" className="align-L sort_asc">
            Event
          </th>
          <th width="5%" data-name="eventName" className="align-L sort_asc">
            Market Name
          </th>
          <th width="5%" data-name="betTime" className="sort_asc">
            Bet Time
          </th>
          <th width="4%" data-name="betType" className="sort_asc">
            Bet Type
          </th>
          <th width="7%" data-name="odds" className="sort_asc">
            Odds
          </th>
          <th width="8%" data-name="stake" className="sort_asc">
            Stake
          </th>
          <th width="5%" data-name="PL" className="sort_asc">
            potProf
          </th>{" "}
          <th width="5%" data-name="PL" className="sort_asc">
            potLiab
          </th>
        </tr>

        {rows && rows.length > 0 ? (
          rows.map((item, index) => {
            const rowId =
              item?.matchBetId || item?.sessionBetId || item?._id || index;
            const subId = `sub_${rowId}`;
            return (
              <React.Fragment key={rowId}>
                <tr style={{ display: "table-row" }}>
                  <td className="align-L">
                    {item?.sessionBetId || item?.matchBetId || "N/A"}
                  </td>
                  <td
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "5%",
                    }}
                    className="align-L"
                  >
                    {`${
                      item?.eventType === "4"
                        ? "Cricket"
                        : item?.eventType === "1"
                          ? "Soccer"
                          : item?.eventType === "2"
                            ? "Tennis"
                            : "Sports"
                    }`}
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    <strong>{item?.matchName}</strong>
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />

                    {item?.fancyName || item?.market}
                  </td>
                  <td className="align-L">
                    {item?.runnerName || item?.fancyName || item?.teamName}
                  </td>{" "}
                  <td>
                    <span className="small-date">
                      {formatDate(item?.timeInserted, user?.timeZone)}
                    </span>
                  </td>
                  <td>{item?.type || item?.betType || "N/A"}</td>
                  <td>
                    {item?.exchangeType === "session"
                      ? `${item?.betRun}/${item?.bhav}`
                      : item?.bhav || "N/A"}
                  </td>
                  <td>{item?.amount || "N/A"}</td>
                  <td>
                    <span className="green">{item?.profitAmount}</span>
                  </td>
                  <td>
                    <span className="red">{item?.loseAmount}</span>
                    <a
                      style={{ width: "20px", float: "right" }}
                      onClick={(e) => toggleRow(e, subId)}
                      className={"expand-close"}
                    />
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={9}>No Data</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

/* ------------------------------------------------------------------------ */
/*  Parlay table                                                            */
/* ------------------------------------------------------------------------ */
function ParlayTable({ rows, tableRef, openRows, toggleRow }) {
  return (
    <table
      ref={tableRef}
      id="table_DL"
      className="table-s"
      style={{ display: "table" }}
    >
      <tbody>
        <tr>
          <th className="align-L sort_asc">Market</th>
          <th className="sort_asc">Bet Placed</th>
          <th className="sort_asc">Bet ID</th>
          <th className="sort_asc">Stake</th>
          <th className="sort_asc">Pot Profit/Loss</th>
        </tr>

        {rows && rows.length > 0 ? (
          rows.map((item, index) => {
            const subId = `sub_${item?._id || index}`;
            const isOpen = !!openRows[subId];
            const legLabel =
              item?.bets?.length === 1
                ? "SINGLE"
                : item?.bets?.length === 2
                  ? "DOUBLE"
                  : item?.bets?.length === 3
                    ? "TREBLE"
                    : item?.bets?.length > 3
                      ? "ACCUMULATOR"
                      : "";

            return (
              <React.Fragment key={item?._id || index}>
                <tr style={{ display: "table-row" }}>
                  <td className="align-L">
                    {item?.isDeclared ? (
                      <strong
                        className={item?.result === "loss" ? "red" : "green"}
                      >
                        {startCase(item?.result)}
                      </strong>
                    ) : (
                      "..."
                    )}
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    <strong>{legLabel}</strong>
                  </td>
                  <td>{formatDate(item?.timeInserted)}</td>
                  <td>{item?.matchBetId}</td>
                  <td>{item?.amount}</td>
                  <td>
                    {item?.isDeclared ? (
                      item?.result === "loss" ? (
                        <strong className="red">
                          {toFixedWithoutRounding(item?.loseAmount)}
                        </strong>
                      ) : (
                        <strong className="green">
                          {toFixedWithoutRounding(item?.profitAmount)}
                        </strong>
                      )
                    ) : (
                      "..."
                    )}
                    {item?.bets?.length > 0 && (
                      <i
                        className={
                          isOpen
                            ? "fas fa-minus-square pe-2"
                            : "fas fa-plus-square pe-2"
                        }
                        style={{ marginLeft: "6px", cursor: "pointer" }}
                        onClick={(e) => toggleRow(e, subId)}
                      />
                    )}
                  </td>
                </tr>

                {item?.bets?.length > 0 && (
                  <tr
                    className="expand"
                    id={subId}
                    style={{ display: isOpen ? "table-row" : "none" }}
                  >
                    <td colSpan={5}>
                      <table>
                        <tbody>
                          <tr>
                            <th className="align-L">Fancy Name</th>
                            <th>Selection</th>
                            <th>Odds</th>
                            <th>Profit/Loss</th>
                          </tr>
                          {item.bets.map((betData, i) => (
                            <tr
                              key={i}
                              className="even"
                              style={{ display: "table-row" }}
                            >
                              <td>{betData?.fancyName}</td>
                              <td>{betData?.runnerName}</td>
                              <td>{betData?.bhav}</td>
                              <td>
                                {betData?.isDeclared ? (
                                  <strong
                                    className={
                                      betData?.result === "loss"
                                        ? "red"
                                        : "green"
                                    }
                                  >
                                    {startCase(betData?.result)}
                                  </strong>
                                ) : (
                                  "..."
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={5}>No Data</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default CurrentBets;
